import { useTranslation } from 'react-i18next';

import type { CampaignInvoiceSubrow } from '../../types';
import { CAMPAIGN_INVOICE_TABLE_SUBROWS } from '../tables/headers/invoices';

export const SubrowTable = ({
  user_id,
  name,
  price,
  status,
  profile_picture,
  billing_date,
  payment_date,
}: CampaignInvoiceSubrow) => {
  const { t } = useTranslation('common');
  return (
    <>
      <div className="cell-class truncate px-3 rounded-l-10 text-start border-influentia-black w-full flex-1">
        <div className="flex justify-start pl-[30px]">
          {CAMPAIGN_INVOICE_TABLE_SUBROWS.influencer.cell(
            name,
            user_id,
            profile_picture,
          )}
        </div>
      </div>
      <div className="cell-class truncate px-3 flex-1 w-full"></div>
      <div className="cell-class truncate px-3 flex-1 w-full"></div>
      <div className="cell-class truncate px-3 flex-1 w-full">
        <div className="flex justify-center">
          {CAMPAIGN_INVOICE_TABLE_SUBROWS.price.cell(price)}
        </div>
      </div>
      <div className="cell-class truncate px-3 flex-1 w-full">
        <div className="flex justify-center">
          {CAMPAIGN_INVOICE_TABLE_SUBROWS.status.cell(status)}
        </div>
      </div>
      <div className="cell-class truncate px-3 flex-1 w-full">
        <div className="flex justify-center">
          {CAMPAIGN_INVOICE_TABLE_SUBROWS.billing_date.cell(billing_date)}
        </div>
      </div>
      <div className="cell-class truncate px-3 flex-1 w-full">
        <div className="flex justify-center">
          {CAMPAIGN_INVOICE_TABLE_SUBROWS.payment_date.cell(payment_date)}
        </div>
      </div>
    </>
  );
};
